import React from 'react'
import './SortProjectsList.scss'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import CheckIcon from '@material-ui/icons/Check'

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiButton-text': {
      padding: '0px 0px 0px 20px'
    }
  },
  sortButton: {
    color: '#007EB0',
    borderRadius: 64,
    backgroundColor: '#F2F4F7',
    border: 'none',
    '& .MuiButton-label': {
      fontSize: 14,
      // fontFamily: '\'Inter\', sans-serif',
      fontFamily: '\'DIN Pro Light\'',
      fontWeight: 600
    }
  },
  iconButton: {
    padding: 8,
    color: '#5E6C84',
    fontSize: '2.5rem'
  },
  arrowBtn: {
    padding: 10
  },
  menuItem: {
    marginRight: 40
  }
}))

const SortByList = [
  { label: 'Last Modified', value: 'last modified' },
  { label: 'Portfolio', value: 'portfolio' },
  { label: 'Lorem Ipsum', value: 'lorem ipsum' },
  { label: 'Dolar Set', value: 'dolar set' },
  { label: 'Amit', value: 'amit' },
  { label: 'Ipsum', value: 'ipsum' }
]
const SortProjectsList = props => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [value, setValue] = React.useState('last modified')
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = val => {
    setAnchorEl(null)
    setValue(val)
  }

  return (
    <div className={classes.root} data-testid="sort-project-list">
      <Button data-testid="sort-project-list-button" className={classes.sortButton} onClick={handleClick}>
        Sort by {value ? value : props.sortBy}
        <div className={classes.arrowBtn}>
          <img src="/images/arrow_drop_down.svg" />
        </div>
      </Button>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} data-testid="sort-project-menu" onClose={handleClose}>
        {
          SortByList.map(sortBy => (
            <MenuItem key={sortBy.value} data-testid={`sort-menu-item_${sortBy.value}`} onClick={() => handleSelect(sortBy.value)}>
              {sortBy.value === value ? <CheckIcon className={classes.iconButton} /> : <span className={classes.menuItem}></span>}
              <span className="sort-menu-item" data-testid="rename">{sortBy.label}</span>
            </MenuItem>
          ))
        }
      </Menu>

    </div>
  )
}

SortProjectsList.propTypes = {
  sortBy: PropTypes.string
}

export default SortProjectsList
